<template>
  <div class="content receipt-note-list">
    <section style="margin-bottom: 1%">
      <a-button type="primary" @click="createHandle">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('新增收款单') }}
      </a-button>
    </section>
    <div class="form-content">
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.receiptNoteSn"
            :placeholder="$t('收款单号')"
          />
        </a-col>
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :code.sync="formData.businessUnitCode"
            :name.sync="formData.businessUnitName"
            :placeholder="$t(`结算组织`)"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <CommonQuerySelect
            api="getAccountDimensionItemList"
            paginate
            :placeholder="$t('往来单位名称')"
            :code.sync="formData.payeeCode"
            :name.sync="formData.payeeName"
            :params="{
              businessUnitCode: formData.businessUnitCode,
              type: 'customer',
            }"
          />
        </a-col>
        <a-col :span="6">
          <SelectDocumentType :docType="docType" :code.sync="formData.orderType" />
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.needGenerateVoucher"
            allow-clear
            :placeholder="$t('能否生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
            <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.voucherGenerated"
            allow-clear
            :placeholder="$t('已生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('是') }}</a-select-option>
            <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt10">
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <CommonTable
      ref="CommonTableRef"
      :statusList="receipt_note_status"
      :columns.sync="columns"
      :loading="loading"
      :dataSource="tableData"
      :scroll="{ x: 1500, y: scrollHeight }"
      :showSelect="true"
      :selectedRowKeys.sync="selectedRowKeys"
      :selectedRows.sync="selectedRows"
      :total="total"
      rowKey="id"
      @select="onSelectChange"
      @search="getList"
    >
      <template v-slot:header>
        <OperateBtn
          api="operateDoc"
          :text="$t('审核')"
          :params="{
            action: 'check',
            docType: docType,
            idList: selectedRowKeys,
          }"
          :disabled="selectedRowKeys.length === 0"
          @success="searchHandle"
        />
        <OperateBtn
          class="ml10"
          :disabled="!selectedRowKeys.length"
          api="operateReceiptNote"
          :text="$t('收款')"
          dateField="receiptDate"
          :dateLabel="$t('收款日期')"
          :params="{
            action: 'receive',
            docType: docType,
            idList: selectedRowKeys,
          }"
          @success="searchHandle"
        />
        <VoucherBtn
          class="ml10"
          :docType="docType"
          :selectedRows="selectedRows"
          :disabled="selectedRows.length === 0"
          @close="searchHandle"
        />
      </template>
      <template v-slot:receiptNoteSn="{ text, record }">
        <a @click="viewDetail(record)">{{ text }}</a>
      </template>
      <template v-slot:receiptAmount="{ text, record }">
        <PriceInput :value="text" :currency="record.receiptCurrency" :showTxt="true" />
      </template>
      <template v-slot:verifiedAmount="{ text, record }">
        <PriceInput :value="text" :currency="record.receiptCurrency" :showTxt="true" />
      </template>
      <template v-slot:unVerifiedAmount="{ text, record }">
        <PriceInput :value="text" :currency="record.receiptCurrency" :showTxt="true" />
      </template>
    </CommonTable>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
import SelectDocumentType from '@component/selectDocumentType'
import { convertKeysToCamelCase, fetchDocumentMappings } from '@/common'
export default {
  name: 'ReceiptNoteList',
  components: { CommonTable, SelectDocumentType },
  data() {
    return {
      docType: 'ReceiptNote',
      formData: {
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      loading: false,
      mappings: {
        orderType: {},
        settlementMethod: {},
      },
    }
  },
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  computed: {
    ...mapState(['receipt_note_status', 'receipt_note_type']),
    ...mapGetters(['receiptNoteTypeMapping', 'receiptNoteStatusMapping', 'currencyListMapping']),
    scrollHeight() {
      return window.innerHeight - 470
    },
    columns() {
      return [
        {
          title: this.$t('收款单号'),
          dataIndex: 'receiptNoteSn',
          width: 200,
          scopedSlots: { customRender: 'receiptNoteSn' },
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'orderType',
          customRender: (text) => this.mappings.orderType[text] || text,
        },
        {
          title: this.$t('单据状态'),
          dataIndex: 'status',
          customRender: (text) => this.receiptNoteStatusMapping[text],
        },
        {
          title: this.$t('收款组织'),
          dataIndex: 'businessUnitName',
        },
        {
          title: this.$t('往来单位类型'),
          dataIndex: 'payeeType',
          customRender: (text) => this.$store.getters.contactTypeMapping[text],
        },
        {
          title: this.$t('往来单位名称'),
          dataIndex: 'payeeName',
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'bizDate',
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('收款币别'),
          dataIndex: 'receiptCurrency',
          customRender: (text) => this.currencyListMapping[text],
        },
        {
          title: this.$t('收款金额'),
          dataIndex: 'receiptAmount',
          scopedSlots: { customRender: 'receiptAmount' },
        },
        {
          title: this.$t('已核销金额'),
          dataIndex: 'verifiedAmount',
          scopedSlots: { customRender: 'verifiedAmount' },
        },
        {
          title: this.$t('未核销金额'),
          dataIndex: 'unVerifiedAmount',
          scopedSlots: { customRender: 'unVerifiedAmount' },
        },
        {
          title: this.$t('结算方式'),
          dataIndex: 'settlementMethodName',
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 100,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 100,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 100,
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 120,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType', 'settlementMethod'])
    },
    reset() {
      Object.assign(this.$data, this.$options.data())
      this.searchHandle(1)
    },
    searchHandle(pageNo) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    createHandle() {
      this.$router.push({ name: 'receiptNoteDetail' })
    },
    async getList(params) {
      if (!this.formData.businessUnitCode) return
      this.loading = true
      await http({
        url: api.getReceiptNoteList,
        data: {
          ...this.formData,
          ...params,
        },
        success: (res) => {
          let result = convertKeysToCamelCase(res.result)
          this.tableData = result.list
          this.total = res.result.total
        },
      })
      this.loading = false
    },
    viewDetail(record) {
      this.addPane({
        view: 'receivableManage/receiptNoteDetail/' + record.receiptNoteSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.receiptNoteSn,
        },
        route: `/receivableManage/receiptNoteDetail?id=${record.id}&sn=${record.receiptNoteSn}`,
      })
    },
  },
}
</script>
